import React, { useState } from 'react'
import './App.css'
import Layout from './components/layout/Layout'
import RechercheOffre from './modules/rechercheOffre/RechercheOffre'
import { createBrowserRouter, RouterProvider, defer } from 'react-router-dom'
import SwiperCore, { Autoplay, Pagination } from 'swiper'
import linksEnum from './enums/linksEnum'
import DetailsOffre from './modules/offre/DetailsOffre'
import Custom404 from './components/404/404'
import { getOffre } from './modules/offre/api/offreApi'
import PlanificationVisite from './modules/planificationVisite/PlanificationVisite'
import RechercheContact from './modules/rechercheContact/RechercheContact'
import CreationContact from './modules/creationContact/CreationContact'
import DetailsContact from './modules/detailsContact/DetailsContact'
import { fetchToken } from './api/authentificationApi'
import localStorageEnum from './enums/localStorageEnum'
import axios from 'axios'
import { httpStatus } from './enums/httpResponseEnum'
import Loader from './components/loader/Loader'
import { useQuery } from '@tanstack/react-query'

SwiperCore.use([Pagination, Autoplay])

function App() {
	axios.interceptors.request.use(function (config) {
		config.headers && localStorage.getItem(localStorageEnum.accessToken) !== null && (config.headers['Authorization'] = `Bearer ${localStorage.getItem(localStorageEnum.accessToken)}`)
		return config
	})

	axios.interceptors.response.use((response) => response, (error) => {
		if (error.response.status === httpStatus.UNAUTHORIZED) {
			window.location.pathname = '/auth/login'
		}

		return Promise.reject(error)
	})

	const [token, setToken] = useState<string>('')

	const { status } = useQuery({ queryKey: ['session'], queryFn: fetchToken, refetchInterval: 900000 })

	if (token === '' && localStorage.getItem(localStorageEnum.accessToken) !== null) {
		setToken(localStorage.getItem(localStorageEnum.accessToken) || '')
	}

	if (status === 'pending' || token === '') {
		return <Loader/>
	}

	const router = createBrowserRouter([
		{
			element: <Layout />,
			children: [
				{
					path: '/',
					element: <RechercheOffre />
				},
				{
					path: `${linksEnum.RECHERCHE_OFFRE}/:filtresRecherche?`,
					element: <RechercheOffre />
				},
				{
					path: `/:lang${linksEnum.OFFRE}/:alias`,
					element: <DetailsOffre />,
					loader: ({ params }) => {
						if (!!params.lang && !!params.alias) {
							const result = getOffre(params.lang, params.alias)
							return defer({ offre: result })
						} else {
							throw new Response('Not Found', { status: 404 })
						}
					},
					errorElement: <Custom404 />
				},
				{
					path: linksEnum.PLANIFICATION_VISITE,
					element: <PlanificationVisite />
				},
				{
					path: linksEnum.RECHERCHE_CONTACT,
					element: <RechercheContact />
				},
				{
					path: linksEnum.CREATION_CONTACT,
					element: <CreationContact />
				},
				{
					path: `${linksEnum.DETAILS_CONTACT}/:client_id`,
					element: <DetailsContact />
				}
			],
			errorElement: <Custom404 />
		}
	])

	return <RouterProvider router={router} />
}

export default App
